import { defineStore } from 'pinia';
import { ref } from 'vue';
import api from '@/services/api';

export const useGeneracionArchivosStore = defineStore('generacionArchivos', () => {
  const programacionList = ref([]);

  const tiposProgramacion = ref([
    { clave: 'PropuestasSisproERP', nombre: 'Propuestas Aprobadas (SisproERP)' },
  ]);

  const getProgramacionesHTTP = async () => {
    try {
      const response = await api.get('/programacion-archivos');
      programacionList.value = response.data;
    } catch (error) {
      console.error('Error al obtener programaciones:', error);
      throw error;
    }
  };

  const saveProgramacionHTTP = async (payload) => {
    try {
      const {
        Codigo,
        UltimaEjecucion,
        UltimoResultado,
        FechaCreacion,
        FechaActualizacion,
        ...dataToSave
      } = payload;

      if (Codigo) {
        await api.put(`/programacion-archivos/${Codigo}`, dataToSave);
      } else {
        await api.post('/programacion-archivos', dataToSave);
      }

      await getProgramacionesHTTP();
    } catch (error) {
      console.error('Error al guardar programación:', error);
      throw error;
    }
  };

  const deleteProgramacionHTTP = async (codigo) => {
    try {
      await api.delete(`/programacion-archivos/${codigo}`);
      await getProgramacionesHTTP();
    } catch (error) {
      console.error('Error al eliminar programación:', error);
      throw error;
    }
  };

  const ejecutarAhoraHTTP = async (codigo) => {
    try {
      await api.post(`/programacion-archivos/${codigo}/ejecutar`);
      await getProgramacionesHTTP();
    } catch (error) {
      console.error('Error al ejecutar manualmente:', error);
      throw error;
    }
  };

  return {
    programacionList,
    tiposProgramacion,
    getProgramacionesHTTP,
    saveProgramacionHTTP,
    deleteProgramacionHTTP,
    ejecutarAhoraHTTP,
  };
});
